import {
    Card,
    CardMedia,
    CardContent,
    Typography,
    ImageList,
    ImageListItem,
    useTheme,
    useMediaQuery
} from "@mui/material";
import Box from "@mui/material/Box";
import {styled} from '@mui/material/styles';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useEffect, useState } from "react";
import { fetchTeams } from "../api/teamsService";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';



const emojiMap = {
    "coeur": "🩷",
    "catamaran": "⛵",
    "rame": "🚣",
    "pluie": "💧",
    "plage": "🏖️",
    "mer": "🌊",
    "lac": "🏞️",
    "sport": "🏃",
    "vélo": "🚴",
    "marche": "🚶",
    "course": "🏃‍♂️",
    "montagne": "⛰️",
    "nature": "🌿",
    "balade": "🥾",
    "fêter": "🎉",
    "rire": "😂",
    "famille": "👨‍👩‍👧‍👦",
    "enfants": "🧒",
    "ami": "👫",
    "groupe": "👥",
    "main": "🤚",
    "aide": "🆘",
    "soleil": "☀️",
    "nuit": "🌙",
    "matin": "🌅",
    "soir": "🌇",
    "hiver": "❄️",
    "été": "🌞",
    "burger": "🍔",
    "pizza": "🍕",
    "boisson": "🥤",
    "repas": "🍽️",
    "fête": "🥳",
    "musique": "🎶",
    "photo": "📸",
    "vidéo": "🎥",
    "cliquez": "👉",
    "info": "ℹ️",
    "contact": "📞",
    "email": "✉️",
    "web": "🌐",
};

function insertEmojis(text) {
    return text.replace(/\b(\w+)\b/gi, (match) => {
        const lower = match.toLowerCase();
        return emojiMap[lower] ? `${emojiMap[lower]} ${match}` : match;
    });
}

const ExpandMore = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== 'expand',
})(({ theme, expand }) => ({
    marginLeft: 'auto',
    transform: expand ? 'rotate(0deg)' : 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

export default function Equipes() {
    const [equipes, setPosts] = useState([]);
    const [loadingTeams, setLoadingTeams] = useState(true);
    const [TeamsError, setTeamsError] = useState(null);
    const [expandedPosts, setExpandedPosts] = useState({});
    const [openImage, setOpenImage] = useState(null); // { url, title } ou null

    const handleOpenImage = (url, title) => {
        setOpenImage({ url, title });
    };
    const handleCloseImage = () => {
        setOpenImage(null);
    };

    useEffect(() => {
        let mounted = true;
        (async () => {
            setLoadingTeams(true);
            try {
                const loaded = await fetchTeams();
                if (mounted) setPosts(loaded);
            } catch (err) {
                if (mounted) setTeamsError(err.message || "Erreur de chargement");
            } finally {
                if (mounted) setLoadingTeams(false);
            }
        })();
        return () => { mounted = false; };
    }, []);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if screen is mobile (width < 600px)

    const handleExpandClick = (postId) => {
        setExpandedPosts((prev) => ({
            ...prev,
            [postId]: !prev[postId],
        }));
    };

    if (loadingTeams) return <Typography>Chargement des équipes…</Typography>;
    if (TeamsError) return <Typography color="error">Erreur: {TeamsError}</Typography>;

    return (
        <Box sx={{ paddingBottom: '50px', paddingTop: '5px'}}>

            <Box sx={{
                flexDirection: "column",
                gap: 3,
                paddingTop: '100px',
                maxWidth: '75%',
                margin:"auto",
                // marginRight:"auto",
                // marginTop:"auto",
                // marginBottom:"100px",
                backgroundColor:"#ffff"
            }}>
                {equipes.map((equipe, index) => (
                    <Card
                        key={index}
                        sx={{
                            backgroundColor:"#fbfdff",
                            marginRight:"auto",
                            marginTop:"auto",
                            marginBottom:"50px"
                        }}
                    >
                        <CardHeader
                            title={equipe.title}
                            sx={{
                                backgroundColor:"#fbfdff"
                            }}
                        />
                        {(equipe.images) &&
                            <CardMedia
                                component="img"
                                image={equipe?.images[0]?.url}
                                alt={equipe?.images[0]?.title}
                                sx={{
                                    width: "90%", // plein largeur du card pour uniformiser
                                    height: 400, // hauteur fixe pour correspondre à la bannière de référence
                                    display: "block",
                                    margin: "0 auto",
                                    cursor: "pointer",
                                    objectFit: 'cover' // recadrage uniforme (comme Octobre_Rose_Groupe.jpg)
                                }}
                                onClick={() => equipe?.images?.[0] && handleOpenImage(equipe.images[0].url, equipe.images[0].title)}
                            />
                        }
                        <CardContent sx={{ backgroundColor:"#fbfdff"}}>
                            {equipe.classement && (
                                <Box sx={{ mt: 2 }}>
                                    <a
                                        href={equipe.classement}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#1976d2', textDecoration: 'underline' }}
                                    >
                                        Voir le classement
                                    </a>
                                </Box>
                            )}
                        </CardContent>
                        <CardActions disableSpacing>
                            <ExpandMore
                                expand={expandedPosts[equipe.id] || false}
                                onClick={() => handleExpandClick(equipe.id)}
                                aria-expanded={expandedPosts[equipe.id] || false}
                                aria-label="plus de détail"
                            >
                                <Typography variant="h5">Plus de photos</Typography>
                                <ExpandMoreIcon/>
                            </ExpandMore>
                        </CardActions>
                        <Collapse in={expandedPosts[equipe.id]} timeout="auto" unmountOnExit>
                            <CardContent>
                                <ImageList cols={isMobile ? 1 : 2} gap={8}>
                                    {equipe?.images.map((item) => (
                                        <ImageListItem key={item.url} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <img
                                                srcSet={`${item.url}?w=492&h=492&fit=scale&auto=format&dpr=2 2x`}
                                                src={`${item.url}?w=492&h=492&fit=scale&auto=format`}
                                                alt={item.title || 'image'}
                                                loading="lazy"
                                                style={{
                                                    width: "100%",
                                                    height: 180, // hauteur fixe pour toutes les vignettes
                                                    objectFit: "cover", // recadrage uniforme pour miniatures
                                                    cursor: "pointer",
                                                    borderRadius: 6
                                                }}
                                                onClick={() => handleOpenImage(item.url, item.title)}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </CardContent>
                        </Collapse>
                    </Card>
                ))}
            </Box>
            <Dialog
                open={!!openImage}
                onClose={handleCloseImage}
                fullWidth
                maxWidth="xl"
                fullScreen={isMobile} // utiliser plein écran sur mobile
                PaperProps={{
                    sx: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }
                }}
            >
                <IconButton
                    onClick={handleCloseImage}
                    sx={{ position: 'absolute', top: 8, right: 8, color: 'white', zIndex: 1301 }}
                    aria-label="fermer"
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        p: 2,
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        borderRadius: 1
                    }}
                >
                    {openImage && (
                        <img
                            src={openImage.url}
                            alt={openImage.title || 'image'}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '90vh',
                                objectFit: 'contain',
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
}
